'use client';

import { createContext, useContext, type ReactNode } from 'react';
import type { ResolvedById } from './useResolveLookupWidgets';

const ResolvedMapContext = createContext<ResolvedById>({});

export function ResolvedMapProvider({
  value,
  children,
}: {
  value: ResolvedById;
  children: ReactNode;
}) {
  return (
    <ResolvedMapContext.Provider value={value}>
      {children}
    </ResolvedMapContext.Provider>
  );
}

export function useResolvedFor(id: string | number): unknown {
  const map = useContext(ResolvedMapContext);
  return map[id];
}
